import * as React from 'react';
import {Svg, G, Path, Defs, ClipPath} from 'react-native-svg';

const SmileIcon = props => {
  return (
    <Svg
      width={72}
      height={72}
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <G
        clipPath="url(#clip0_2222_29508)"
        stroke="#fff"
        strokeWidth={5}
        strokeLinecap="round">
        <Path d="M36 69.333c18.41 0 33.333-14.924 33.333-33.333C69.333 17.59 54.41 2.666 36 2.666 17.59 2.666 2.667 17.59 2.667 36 2.667 54.41 17.59 69.333 36 69.333zM22.667 26.166v-.333m26.666.333v-.333" />
        <Path
          d="M49.333 42.666c-1.666 5-5.966 10-13.333 10s-11.667-5-13.333-10"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_2222_29508">
          <Path fill="#fff" d="M0 0H72V72H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
};

export default SmileIcon;
